import { createStyles } from 'antd-style'

import { BizTypeTag } from '@eastcoal/shared/components/BizTypeTag'

import { TradeSessionDetailTitleProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: token.paddingXS
  },
  title: {
    paddingBlock: token.paddingXS,
    fontSize: token.fontSizeHeading4,
    fontWeight: token.fontWeightStrong
  }
}))

export const TradeSessionDetailTitle = ({
  className,
  style,
  bizType,
  title
}: TradeSessionDetailTitleProps) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      <BizTypeTag type={bizType} />
      <span className={styles.title}>{title}</span>
    </div>
  )
}
